/**
 * Created by jonas on 2022-06-15.
 */
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../TheCage";
import {TheCageSound} from "../../sound/TheCageSound";
import {ReelUtils} from "../../utils/ReelUtils";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";


export class FreeSpinsDropInPresentation implements SimplePresentation {
    name:string = "FreeSpinsDropInPresentation";

    constructor() {}

    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(()=>{ReelUtils.resetScatter()});
        tl.add(() => controller.setSkipCallback(() =>{
            //tl.seek("ending", false);
            tl.timeScale(3);
        }));

        tl.add(TheCage.freeSpinReelView.features.reactive());
        tl.add(()=>{
            TheCage.soundPlayer.playSound(TheCageSound.REELS_IN);
        });
        tl.add(TheCage.freeSpinReelView.avalancheMatrixModel.dropIn(TheCage.model.gameData.reels));

        tl.addLabel("ending");
        tl.add(() => controller.setSkipCallback());
        tl.to(this, {duration:0.01});

        if (TheCage.apiPlugin.settings.get(APISetting.FAST_SPIN)){
            tl.timeScale(1.4);
        }

    }
}
